<div class="headerText">Work Order Renewals</div>

<br/>
<div>
  <app-work-order-filter-bar
    [isDayView]="true"
    [isWellnessRenewal]="true"
    [typeOfWorkOrders]="'wellness'"
    [rms]="rms"
    [equipmentTypes]="equipmentTypes"
    [zipCodes]="zipCodes"
    [hideRMAndZip]="hideRMAndZip"
    [showRefresh]="true"
    (OnWoFilteringFinished)="OnWoFilteringFinished()"
    (forceRefresh)="OnWoFilteringFinished($event)"
    >
  </app-work-order-filter-bar>
</div>

@if (rms) {
  <p-table 
    [columns]="cols" 
    [value]="allWorkOrders" 
    [paginator]="true" 
    [rows]="rows" 
    [responsive]="true"
    [lazy]="true"
    (onLazyLoad)="loadRequestLazy($event)"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    [sortField]="'FullName'"
    [sortOrder]="1"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.info) {
              <i class="pi pi-info-circle" [pTooltip]="col.info" tooltipPosition="bottom" style="vertical-align: sub;"></i>
            }
            @if (col.header != '') {
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-workOrder let-columns="columns" let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{workOrder.fullName}}</td>
        <td><span class="p-column-title">{{columns[1].header}}</span>{{workOrder.number}}</td>
        <td><span class="p-column-title">{{columns[2].header}}</span>{{workOrder.createdOn | date: 'shortDate' }}</td>
        <td><span class="p-column-title">{{columns[3].header}}</span>{{workOrder.status}}</td>
        <td><span class="p-column-title">{{columns[4].header}}</span>{{workOrder.completedDate | date: 'shortDate' }}</td>
        <td><span class="p-column-title">{{columns[5].header}}</span>{{workOrder.zip}}</td>
        <td><span class="p-column-title">{{columns[6].header}}</span><span [innerHTML]="workOrder.taskNames | bold:biannualTasks"></span></td>
        <td><span class="p-column-title">{{columns[7].header}}</span>{{workOrder.anyRenewalAccepted == true ? 'Yes' : 'No'}}</td>
        <td><span class="p-column-title">{{columns[8].header}}</span>{{workOrder.anyNeedsRenewed == true ? 'Yes' : 'No'}}</td>
        <td>
          <button pButton type="button" (click)="edit('wellnessWorkOrderMaintenance/' + workOrder.id)" icon="pi pi-pencil" severity="info">
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="empty-table-row">
        <td [attr.colspan]="10">
          No work orders met your criteria.
        </td>
      </tr>
    </ng-template>
  </p-table>
}